module.exports = __webpack_public_path__ + "img/reward-1.851bfe68.webp";